import React, { useState } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import useGlobalQueries from '../hooks/useGlobalQueries';

import PublishLocalesModalDropdownItem from './publishLocalesModalDropdownItem';

import styles from '../styles/publishLocalesModal.module.scss';

const PublishLocalesModalSelected = ({
  handleCheckboxChange = () => {},
  currentLocale = '',
  locales = [],
  selectedLocales = [],
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const localeLabels = useGlobalQueries().adminSettings.data.locales;

  const buttonId = 'publish-additional-locale-dropdown';

  return (
    <div className={styles.publishToLocales}>
      <Button
        className={classNames(styles.menuButton, styles.actionButton)}
        size="small"
        variant="ghost"
        icon={isMenuOpen ? <ArrowDropUp /> : <ArrowDropDown />}
        iconPosition="right"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        id={buttonId}
        aria-expanded={isMenuOpen}
        aria-label={i18n.t('publish-to-additional-locales-dropdown')}
      >
        <Typo element="span" variant="s03" weight="medium">
          {i18n.t('publish-to-additional-locales')}
        </Typo>
      </Button>
      {isMenuOpen && (
        <ul aria-labelledby={buttonId}>
          {locales
            .filter(({ locale }) => locale !== currentLocale)
            .map(
              ({
                id,
                locale,
                published_at: publishedAt,
                is_published: isPublished,
                version_state_updated_at: updatedAt,
                has_unpublished_changes: hasUnpublishedChanges,
                status,
              }) => (
                <PublishLocalesModalDropdownItem
                  key={id}
                  selectedLocales={selectedLocales}
                  handleCheckboxChange={handleCheckboxChange}
                  id={id}
                  localeLabels={localeLabels}
                  locale={locale}
                  updatedAt={updatedAt}
                  publishedAt={publishedAt}
                  hasUnpublishedChanges={hasUnpublishedChanges}
                  status={status}
                  isPublished={isPublished}
                />
              ),
            )}
        </ul>
      )}
    </div>
  );
};

PublishLocalesModalSelected.propTypes = {
  currentLocale: PropTypes.string,
  handleCheckboxChange: PropTypes.func,
  locales: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      locale: PropTypes.string,
      published_at: PropTypes.string,
      state: PropTypes.string,
      has_unpublished_changes: PropTypes.bool,
      is_published: PropTypes.bool,
      version_state_updated_at: PropTypes.string,
    }),
  ),
  selectedLocales: PropTypes.arrayOf(PropTypes.string),
};

export default PublishLocalesModalSelected;
